import { render } from "./ZonesTable.vue?vue&type=template&id=37999502"
import script from "./ZonesTable.vue?vue&type=script&lang=ts"
export * from "./ZonesTable.vue?vue&type=script&lang=ts"

import "./ZonesTable.vue?vue&type=style&index=0&id=37999502&lang=scss"
script.render = render

export default script